import React, {useState, useEffect} from 'react';

/* This example requires Tailwind CSS v2.0+ */
import { PaperClipIcon, UserCircleIcon } from '@heroicons/react/solid'

import {Button, Spinner, Modal, SelectionInput} from 'player-components';
import './style.css';


const LoggingInModal = ({loginLogo}) => {



    const renderContent = () => {
        return <div className="flex flex-col align-center justify-center text-center">
          <img src={loginLogo} alt="Choir Player"  className="h-20" />
          <h1 className="text-xl font-bold m-4">Logging in...</h1>
          <div className="flex justify-center mt-4"><Spinner /></div>
        </div>
    }

    return <div style={{position: 'absolute', left: 0, right:0, bottom: 0, top: 0, background: 'white'}}><Modal 
    isOpen={true}
    content={renderContent()}
    onClose={()=>{}}
/></div>
}

export default LoggingInModal;